import {
  FETCH_PRODUCTS,
  PUSH_PRODUCTS,
  UPDATE_PRODUCTS,
  REMOVE_PRODUCTS,
 } from '../actions/productsActions';

const INITIAL_STATE = {
  data: [],
}

export default function productReducer(state = INITIAL_STATE, action){
  switch(action.type){
    case FETCH_PRODUCTS:
      return {
        ...state,
        data:action.data,
      }
    case PUSH_PRODUCTS:
      return {
        ...state,
        data:[action.data, ...state.data],
      }
    case UPDATE_PRODUCTS:
      let updated = state.data.map((v)=>{
        if(v._id === action.data._id) {
          return action.data
        } else return v
      })
      return {
        ...state,
        data: updated
      }
    case REMOVE_PRODUCTS:
      return {
        ...state,
        data: [...state.data.filter( (item) => item._id !== action.data._id)]
      }
    default:
      return state

  }
}